// extracted by mini-css-extract-plugin
export default {"divInfoWarning":"CertidaoQuitacao_divInfoWarning__3w92-","modalCard":"CertidaoQuitacao_modalCard__lQfqN","modalCardImportado":"CertidaoQuitacao_modalCardImportado__Ls0SQ"};